import { Box, Button, Flex, Image, UnstyledButton } from "@mantine/core"
import type { FC, PropsWithChildren } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import AppFooter from "@components/navigation/AppFooter"
import styles from "./PageWithHeaderBackButton.module.css"
import cPLogo from "@assets/svg/cp-logo.svg"
import { IconCaretLeftFilled } from "@tabler/icons-react"
import { useIsMobile } from "@utils/device.utils"
import { useAuthContext } from "@context/AuthProvider"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"
import { useComplexBackNavigation } from "@hooks/useComplexBackNavigation"

export const PageWithHeaderBackButton: FC<PropsWithChildren> = ({
	children
}) => {
	const { isAuthenticated } = useAuthContext()
	const { dictionary } = useAEMDictionary()
	const isMobile = useIsMobile()
	const navigate = useNavigate()
	const { handleBackNavigation } = useComplexBackNavigation()

	if (isAuthenticated) {
		return <Navigate to="/home" replace />
	}

	return (
		<Flex className={styles.pageWrapper}>
			<Box className={styles.header}>
				<Flex justify="space-between" align="center" h="100%">
					<Button
						c="var(--text-color-primary)"
						variant="transparent"
						size="md"
						p={0}
						leftSection={<IconCaretLeftFilled size={18} />}
						onClick={handleBackNavigation}
					>
						{!isMobile && dictionary?.backButton}
					</Button>

					<UnstyledButton
						onClick={() => navigate("/login")}
						aria-label="Navigate to CruisingPower login page"
					>
						<Image
							src={cPLogo}
							alt="Company Logo"
							w={{ base: 199, sm: 214 }}
							h={{ base: 28, sm: 31 }}
						/>
					</UnstyledButton>

					<Box w={60} />
				</Flex>
			</Box>

			<Box className={styles.pageContent}>{children}</Box>
			<AppFooter />
		</Flex>
	)
}
